import resume from './Andrew Resume.pdf';

export default function aboutMe() {
  return (
    <section className="content" id='About'>
      <h1 className='mb-0 about-name'>
        Andrew Fang
      </h1>
      <div className='contact mb-3'>
        (+65) 9147-7565 · <a href="mailto:fangggandrew@gmail.com">FANGGGANDREW@GMAIL.COM</a>
      </div>

      <p className='lead'>
        I am a graduate of Nanyang Polytechnic with a diploma in Applied AI and Analytics. I have completed multiple projects related to Natural Language Processing, 
        Machine Learning, and Data Science at Nanyang Polytechnic and an internship at CSIT. My expertise is harnessing the power of data to train predictive models, 
        deriving insights from raw data, and deploying machine learning solutions. My interests includes skateboarding, badminton, and travelling.
      </p>
      
      <div className='container'>
        <div className='row mb-0'>
          <a target='_blank' className='btn' href={resume}>
            <i className='fa fa-download'></i> 
            Download my resume
          </a>
        </div>
        
        <div className='row socials mb-5'>
          <a className='social-icons' href="https://github.com/exfang">
            <i className="fa-brands fa-square-github"></i>
          </a>
          <a className='social-icons' href="https://www.linkedin.com/in/andrewfbj">
            <i className="fa-brands fa-linkedin"></i>  
          </a>
        </div>
        
        <div className='row down mb-3'>
          <a href="#Projects"><i className="fas fa-arrow-down"></i></a>
        </div>
        
      </div>
      
    </section>
  );
}